export const proxyImageUrl = (url: string | null | undefined): string => {
  if (!url) return '';
  
  if (!import.meta.env.DEV) return url;
  
  if (url.startsWith('https://imgs.aitcyc.com/')) {
    return url.replace('https://imgs.aitcyc.com/', '/imgs-proxy/');
  }
  
  if (url.startsWith('https://oss.aitcyc.com/')) {
    return url.replace('https://oss.aitcyc.com/', '/oss-proxy/');
  }
  
  return url;
};
